// extracted by mini-css-extract-plugin
module.exports = {"max_width":"homepage-management_max_width__MAgam","pageContainer":"homepage-management_pageContainer__2T4c_","mainTitle":"homepage-management_mainTitle__zOo2o"};